<script setup lang="ts">

</script>

<template>
<div class="page-products">
  <NuxtPage />
</div>
</template>
<style lang="scss">

.io-hero {
  &.product-page {
    min-height: 600px !important;
  }
}

</style>

<style lang="scss" scoped>

</style>